import { onBeforeUnmount, getCurrentInstance } from 'vue'

import { useSite } from '@/composables/core/useSite'
import { useUserInfo } from '@/composables/user/useUserInfo'
import { useMainStore } from '@/stores/main'
import customerService from '@/utils/customerService'
import { isTrue } from '@/utils/siteConfigChecker'

export function useCustomerServiceMenu() {
  const nuxtApp = useNuxtApp()

  // 使用 useState 確保 SSR 安全：每個請求獨立的狀態，client 端則共享
  const showCsMenu = useState('cs-menu-visible', () => false)
  const { csChat } = useSite()
  const { userInfo } = useUserInfo({ autoInit: false })
  const mainStore = useMainStore()
  const { setModal, setModalParams } = mainStore

  // SSR-safe: 使用 nuxtApp context 存儲 timer，避免記憶體洩漏
  if (!nuxtApp._csMenuContext) {
    nuxtApp._csMenuContext = {
      closeTimer: null,
    }
  }
  const ctx = nuxtApp._csMenuContext

  // 取得已啟用的客服列表
  const getEnabledCsList = () => {
    return csChat.value?.filter((item) => isTrue(item.enable)) || []
  }

  // 顯示客服（處理單一客服或多客服選單的邏輯）
  const showCustomerService = () => {
    const enableCS = getEnabledCsList()

    if (enableCS.length > 1) {
      // 多個客服選項：顯示選單
      showCsMenu.value = true
    } else if (enableCS.length === 1) {
      // 單一客服選項：直接開啟
      const cs = enableCS[0]
      if (cs.name === 'customermessage') {
        setModalParams({ tabType: 'CUSTOMER' })
        setModal('ModalInbox')
      } else {
        customerService.doAction(cs, 'setUser', userInfo.value?.uid_site)
        customerService.doAction(cs, 'maximize')
      }
    }
  }

  // 關閉客服選單
  const closeCustomerService = () => {
    // 清除舊的計時器，避免累積
    if (ctx.closeTimer) {
      clearTimeout(ctx.closeTimer)
      ctx.closeTimer = null
    }

    ctx.closeTimer = setTimeout(() => {
      showCsMenu.value = false
      ctx.closeTimer = null
    }, 500)
  }

  // 元件卸載時清理 timer，避免記憶體洩漏
  if (getCurrentInstance()) {
    onBeforeUnmount(() => {
      if (ctx.closeTimer) {
        clearTimeout(ctx.closeTimer)
        ctx.closeTimer = null
      }
    })
  }

  // 直接設定選單顯示狀態（給外部直接控制用）
  const setCsMenuVisible = (visible) => {
    showCsMenu.value = visible
  }

  return {
    showCsMenu,
    showCustomerService,
    closeCustomerService,
    setCsMenuVisible,
    getEnabledCsList,
  }
}
